import Skeleton, { SkeletonTheme } from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
const LoadingPackagesColumn = () => {
  return (
    <SkeletonTheme baseColor="#F9F9F9" highlightColor="#eee">
      {Array(9)
        .fill({})
        .map((item, key) => {
          return (
            <div key={key} className="col-xl-4 col-lg-6 col-md-6 mb-4">
              <div className="item">
                <div className="pl-1 pr-1">
                  <Skeleton direction="rtl" height="40px" width="100%" />
                </div>
                <div className="body">
                  <div className="p-2 text-center mt-auto mb-auto">
                    <Skeleton direction="rtl" height="10px" width="150px" />
                    <Skeleton direction="rtl" height="10px" width="150px" />
                  </div>

                  <div className="holder-show-option">
                    <div className="item">
                      <span className="label">
                        <Skeleton direction="rtl" height="10px" width="50%" />
                      </span>
                      <span className="value">
                        <Skeleton direction="rtl" height="10px" width="70%" />
                      </span>
                    </div>

                    <div className="item">
                      <span className="label">
                        <Skeleton direction="rtl" height="10px" width="50%" />
                      </span>
                      <span className="value">
                        <Skeleton direction="rtl" height="10px" width="70%" />
                      </span>
                    </div>
                  </div>
                </div>
                <div className="footer">
                  <div className="row-item">
                    <div className="hold-price">
                      <h3>
                        <Skeleton direction="rtl" height="10px" width="50%" />
                      </h3>
                    </div>
                    <div className="hold-button">
                      <Skeleton
                        direction="rtl"
                        height="30px"
                        width="50%"
                        style={{ borderRadius: "5px" }}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          );
        })}
    </SkeletonTheme>
  );
};

export default LoadingPackagesColumn;

export const LoadingPackagesRows = () => {
  return (
    <SkeletonTheme baseColor="#F9F9F9" highlightColor="#eee">
      {Array(10)
        .fill({})
        .map((index, key) => {
          return (
            <div key={key} className="col-12 mb-3">
              <div className="row-item">
                <div
                  className="holder-small-row"
                  style={{ background: "#fff" }}
                >
                  <div className="hold-show-option">
                    <div className="hold-title">
                      <div className="pre-title">
                        <div className="hold-type">
                          <span
                            className="p-3"
                            style={{ width: "60px", display: "block" }}
                          ></span>
                        </div>
                        <h3>
                          <Skeleton direction="rtl" height="10px" width="50%" />
                        </h3>
                        <p>
                          <Skeleton direction="rtl" height="10px" width="50%" />
                        </p>
                      </div>
                    </div>
                    <div className="hold-footer">
                      <div className="hold-price">
                        <div className="price">
                          <span>
                            <Skeleton
                              direction="rtl"
                              height="10px"
                              width="50%"
                            />
                          </span>
                        </div>
                      </div>
                      <div className="hold-button">
                        <Skeleton direction="rtl" height="30px" width="50%" />
                      </div>
                    </div>
                  </div>
                </div>
                <div className="holder-big-row" style={{ background: "#fff" }}>
                  <div className="hold-title">
                    <h3>
                      <Skeleton direction="rtl" height="10px" width="50%" />
                    </h3>
                    <p>
                      <Skeleton direction="rtl" height="10px" width="50%" />
                    </p>
                  </div>
                  <div className="hold-type">
                    <Skeleton direction="rtl" height="10px" width="50%" />
                  </div>
                  <div className="hold-ussd m-auto">
                    <Skeleton direction="rtl" height="10px" width="50%" />
                  </div>
                  <div className="hold-price">
                    <Skeleton direction="rtl" height="10px" width="50%" />
                  </div>
                  <div className="hold-button m-auto">
                    <Skeleton direction="rtl" height="30px" width="50%" />
                  </div>
                </div>
              </div>
            </div>
          );
        })}
    </SkeletonTheme>
  );
};

export const LoadingPackageFactor = () => {
  return (
    <SkeletonTheme baseColor="#F9F9F9" highlightColor="#eee">
      <div className="holder-factor">
        <div className="holder-icon-factor">
          <div className="shareicon">
            <Skeleton direction="rtl" height="32px" circle width="32px" />
          </div>
          <div className="downloadicon">
            <Skeleton direction="rtl" height="32px" circle width="32px" />
          </div>
        </div>
        <div className="holder-icon-status text-center">
          <Skeleton direction="rtl" height="100px" circle width="100px" />
        </div>
        <div className="holder-title-status">
          <h2>
            <Skeleton direction="rtl" height="10px" width="100px" />
          </h2>
        </div>
        <div className="holder-list-result">
          <ul className="list-unstyled">
            <li>
              <div className="label">
                <Skeleton direction="rtl" height="10px" width="100px" />
              </div>
              <div className="value">
                <Skeleton direction="rtl" height="10px" width="100px" />
              </div>
            </li>
            <li>
              <div className="label">
                <Skeleton direction="rtl" height="10px" width="100px" />
              </div>
              <div className="value">
                <Skeleton direction="rtl" height="10px" width="100px" />
              </div>
            </li>

            <li>
              <div className="label">
                <Skeleton direction="rtl" height="10px" width="100px" />
              </div>
              <div className="value">
                <Skeleton direction="rtl" height="10px" width="100px" />
              </div>
            </li>

            <li>
              <div className="label">
                <Skeleton direction="rtl" height="10px" width="100px" />
              </div>
              <div className="value">
                <Skeleton direction="rtl" height="10px" width="100px" />
              </div>
            </li>
            <li>
              <div className="label">
                <Skeleton direction="rtl" height="10px" width="100px" />
              </div>
              <div className="value">
                <Skeleton direction="rtl" height="10px" width="100px" />
              </div>
            </li>
            <li>
              <div className="label">
                <Skeleton direction="rtl" height="10px" width="100px" />
              </div>
              <div className="value">
                <Skeleton direction="rtl" height="10px" width="100px" />
              </div>
            </li>
          </ul>
        </div>
        <div className="holder-button text-center">
          <Skeleton direction="rtl" height="40px" width="200px" />
        </div>
      </div>
    </SkeletonTheme>
  );
};
